import React from 'react'
import GatewayType from '../GatewayType'
import { UseOldUI } from '../../utils/GeneralUtil'

const ProxyUsers: GatewayType = () => {
  return <UseOldUI />
}

export default ProxyUsers
